import { SVGProps, Ref, forwardRef } from 'react';

export const PriceTagFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M16.5 5.8c.88 0 1.207.272 1.352.446.193.232.348.646.348 1.254s-.155 1.022-.348 1.254c-.145.174-.472.446-1.352.446s-1.207-.272-1.352-.446c-.193-.232-.348-.646-.348-1.254s.155-1.022.348-1.254c.145-.174.472-.446 1.352-.446"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m24 12-8.003 8.003-.941.937q-.323.32-.62.604-.162.155-.317.3-.165.158-.324.302c-1.351 1.237-2.327 1.857-3.455 1.857-1.657 0-2.99-1.334-5.657-4l-.686-.686C1.414 16.734.082 15.402.001 13.815l-.004-.155c0-1.45 1.021-2.651 3.063-4.716l.937-.941L12 0h12zm-7.5-8c-2.46 0-3.383 1.538-3.49 3.172L13 7.5c0 1.695.821 3.39 3.259 3.495L16.5 11c2.625 0 3.5-1.75 3.5-3.5l-.01-.328c-.103-1.58-.969-3.07-3.249-3.167z"
                fill="currentColor"
            />
            <path
                d="M22.349 17.418c-1.107 3.629-1.66 5.443-3.132 6.22-1.06.56-2.295.423-4.255-.119.436-.396.887-.833 1.36-1.3l.004-.003.942-.938.002-.003 5.614-5.615z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PriceTagFilledSize24Glyph.displayName = 'PriceTagFilledSize24Glyph';
